import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { cx } from '../internal/variants.js';
import { Icon } from '../primitives/Icon.js';
export function RuleId({ id, version, onClick, chip = false, size }) {
    const inner = (_jsxs("span", { className: "ruleid", style: size !== undefined ? { fontSize: size } : undefined, children: [id, version !== undefined && _jsxs("span", { className: "ver", children: [".v", version] })] }));
    if (chip) {
        return (_jsxs("span", { className: "ruleid-chip", onClick: onClick, role: onClick ? 'button' : undefined, tabIndex: onClick ? 0 : undefined, children: [inner, onClick && _jsx(Icon, { name: "arrow", size: 11, color: "var(--fg-3)" })] }));
    }
    if (onClick) {
        return (_jsx("span", { className: cx('cite-link'), role: "button", tabIndex: 0, onClick: onClick, style: { cursor: 'pointer' }, children: inner }));
    }
    return inner;
}
//# sourceMappingURL=RuleId.js.map